import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IonButton, IonSpinner } from '@ionic/angular/standalone';

@Component({
  selector: 'app-student-slip-loading',
  templateUrl: './student-slip-loading.component.html',
  styleUrls: ['./student-slip-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonSpinner, IonButton]
})
export class StudentSlipLoadingComponent {
  @Input() working: boolean;
  @Input() error: string;
  @Output() retry = new EventEmitter<void>();
}
